<template>
  <div>
    <p>You have reached the login page.</p>
    <landing v-if="! userSession.isUserSignedIn()"></landing>
    <div v-else>User already logged in</div>
  </div>
</template>

<script>
import Landing from "@/components/Landing";

export default {
  name: "Home",
  components: {
    Landing
  },
  created() {
    this.userSession = userSession;
  },
  mounted() {
    console.log("Login mounted");
    if (userSession.isUserSignedIn()) {
      console.log("user already logged in, forwarding to todos");
      this.$router.push("/todos");
    } else if (userSession.isSignInPending()) {
      userSession.handlePendingSignIn().then(userData => {
        console.log("user pending log in finished, forwarding to todos");
        this.$router.push("/todos");
      });
    }
    console.log("Login mounted routine finished...");
  },
  data() {
    return {
      userSession: null,
      user: null
    };
  }
};
</script>

<style scoped>
div {
  padding: 20px;
}
</style>

